import { useMutation, useQueryClient } from '@tanstack/react-query';
import { surveysQueryKeys } from '../Constants/queryKeys';
import { SurveyMissingTranslationsError } from '../Services/Surveys.errors';
import { approveSurvey } from '../Services/Surveys.service';
import { useActionToast } from '@/Hooks/useActionToast';

/**
 * Approves the survey, and lets a missing translation through untouched.
 *
 * The `422` carries which languages are missing, and the screen names them (R6). A toast saying
 * "não foi possível aprovar" would throw away the only part of the answer that tells the person
 * what to do next, so it is raised as-is and the caller renders it.
 */
export const useApproveSurvey = () => {
  const queryClient = useQueryClient();
  const toast = useActionToast();

  return useMutation({
    mutationFn: (id: string) => approveSurvey(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.details() });
      queryClient.invalidateQueries({ queryKey: surveysQueryKeys.lists() });
      toast.success('Pesquisa aprovada', 'A partir de agora ela pode ser entregue.');
    },
    onError: (error: Error) => {
      if (error instanceof SurveyMissingTranslationsError) return;

      toast.failure('Não foi possível aprovar a pesquisa', error);
    },
  });
};
